import { Stack, Typography } from "@mui/material";
import { BackButton, StyledLink } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  StyledBackButtonBox,
  StyledLinkApplicationSubTextBox,
} from "../../../Styles/LinkApplication/LinkMyApplication";
import {
  LINK_APPLICATION_ALREADY_TEXT,
  LINK_APPLICATION_TEXT,
  LINK_APPLICATION_TEXT_LOGIN,
  PERSONAL_INFORMATION_HEADING,
  SEARCH_HAP_ID_HEADING,
} from "../../../Constants/LinkMyApplicationConstants";
import SearchHapIdForm from "./SearchHapIdForm";
import {
  BACK_BUTTON_TEXT,
  BUTTON,
  COMPONENT_H1,
  COMPONENT_H2,
  LINK_APPLICATION_ROUTE,
  LOGIN_ROUTE,
  LOG_IN,
  SECONDARY_MAIN,
  VARIANT_H3,
  VARIANT_H4,
  VARIANT_P_REGULAR,
} from "../../../Constants/CommonConstants";

/**
 * Main Search Hap Id component that renders the form for Searching the Hap Id
 * @returns {ReactNode} react component with the entire form for searching the hap id
 */
const SearchHapId = () => {
  const intl = useIntl();

  const navigate = useNavigate();

  const onBackButtonClickHandler = () => {
    navigate(`/${LINK_APPLICATION_ROUTE}`);
  };

  const onLoginClickHandler = () => {
    navigate(`/${LOGIN_ROUTE}`);
  };

  return (
    <Stack spacing={3}>
      <Stack spacing={{ xs: 3, md: 5 }}>
        <StyledBackButtonBox>
          <BackButton
            id={BACK_BUTTON_TEXT}
            backButtonText={intl.formatMessage({ id: BACK_BUTTON_TEXT })}
            backButtonOnClickHandler={onBackButtonClickHandler}
          />
        </StyledBackButtonBox>
        <Stack spacing={{ xs: 3, md: 2 }}>
          <Typography
            component={COMPONENT_H1}
            variant={VARIANT_H3}
            color={SECONDARY_MAIN}
            id={SEARCH_HAP_ID_HEADING}
          >
            {intl.formatMessage({ id: SEARCH_HAP_ID_HEADING })}
          </Typography>
          <Stack spacing={5}>
            <StyledLinkApplicationSubTextBox>
              <Typography
                variant={VARIANT_P_REGULAR}
                id={LINK_APPLICATION_TEXT}
              >
                {intl.formatMessage({ id: LINK_APPLICATION_ALREADY_TEXT })}
              </Typography>
              <StyledLink
                id={LOG_IN}
                onClick={onLoginClickHandler}
                component={BUTTON}
                type={BUTTON}
              >
                {intl.formatMessage({ id: LINK_APPLICATION_TEXT_LOGIN })}
              </StyledLink>
            </StyledLinkApplicationSubTextBox>
            <Typography
              variant={VARIANT_H4}
              component={COMPONENT_H2}
              id={PERSONAL_INFORMATION_HEADING}
            >
              {intl.formatMessage({ id: PERSONAL_INFORMATION_HEADING })}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <SearchHapIdForm />
    </Stack>
  );
};

export default SearchHapId;
